let appUrl = `//${document.location.host}/`;
let environment = "PRODUCTION";
if (appUrl.endsWith(":3000/")) {
  appUrl = "//refin-api.ddev.site/";
  environment = "DEVELOPER";
} else if (document.location.href.indexOf("/staging") !== -1) {
  appUrl = `${appUrl}staging/`;
} else {
  appUrl = `${appUrl}monitoring/`;
}
export const APP_URL = appUrl;
export const API_URL = `${APP_URL}api`;
export const SIGNUP_URL = `${APP_URL}signup/`;
export const VERSION = "1.0.19";
export const DRAWER_WIDTH = 260;
export const APP_TITLE = "Refin";
export const ENVIRONMENT = environment;
export const MAX_FILE_SIZE = 100000000; // 20 MB
export const ACCEPTED_FILE_TYPES = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".gif",
  ".png",
  ".jpg",
  ".jpeg",
  ".bmp",
  ".zip",
];
